<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div>
          <button type="button" id="BtnPopup" (click)="getpopupdetails()" style="display:none">Search</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>
        <!--popup-->
        <div id="btnPopupGridDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title">{{Popuptitle}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <div class="modal-body" id="popupbody">
                <!--popup body-->
                <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul" >
                  <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#divGridmastertab">GridColumnMaster</a></li>
                  <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#divGridTrans">GridColumnMasterTrans</a></li>
                  <li class="nav-item" id="tab_btn" ><button class="btn btn-outline-info waves-effect waves-light spAddIcon" (click)="addNewRow()"><i class="fa fa-plus"></i> Add</button></li>           
                </ul><br />
                <!--tab body-->
                <div class="tab-content">
                  <div class="tab-pane active" id="divGridmastertab">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4">
                          GridName<em style="color:red">*</em>
                          <input id="Txt_GridName" type="text" class="form-control " maxlength="40" autocomplete="off" />
                        </div>
                        <div class="col-sm-4">
                          ModuleName <em>*</em>
                          <input id="Txt_ModuleName" type="text" class="form-control" maxlength="40" autocomplete="off" />
                        </div>
                        <div class="col-sm-4">
                          Publisher
                          <select id="ddlPublisherList" class="form-control">
                            <option selected value="0">Select</option>
                            <option *ngFor="let item of GetPublisherList" value={{item.ID}}>
                              {{item.PublisherName}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-4">
                          TableName<em style="color:red">*</em>
                          <input id="Txt_TableName" type="text" class="form-control " maxlength="40" autocomplete="off" />
                        </div>
                        <div class="col-sm-4">
                          DU_IconViewStatus
                          <input id="Txt_DU_IconViewStatus" type="text" class="form-control " maxlength="40" autocomplete="off" />
                        </div>
                        <div class="col-sm-4">
                          Actionitem
                          <select id="ddlActionitem" class="form-control">
                            <option selected value="null">Select</option>
                            <option *ngFor="let item of GetGroupbyAction" value={{item.ActionsItems}}>
                              {{item.ActionsItems}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-3">
                          ExportExcel &nbsp;
                          <input type="checkbox" id="Txt_ExportExcel" />
                        </div>
                        <div class="col-sm-3">
                          ExportPDF&nbsp;
                          <input type="checkbox" id="Txt_ExportPDF" />
                        </div>
                        <div class="col-sm-3">
                          ExportCSV&nbsp;
                          <input type="checkbox" id="Txt_ExportCSV" />
                        </div>
                        <div class="col-sm-3">
                          ExportWord&nbsp;
                          <input type="checkbox" id="Txt_ExportWord" />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-sm-4">
                          Remarks
                          <textarea class="form-control" id="Txt_Remarks" autocomplete="off"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane" id="divGridTrans">
                    <!--Table-->
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row tblcolumtans col-md-12 fixTableHead">
                          <table class="table" id="tblcolumtans">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>ColumnData</th>
                                <th>ColumnTitle</th>
                                <th>ColumnDataType</th>
                                <th>ColumnReturnData</th>
                                <th>Sortable</th>
                                <th>Alignment</th>
                                <th>Actions</th>
                                <th>DisplayOrder</th>
                                <th>Visible</th>
                                <th>IsDelete</th>
                              </tr>
                            </thead>
                            <tbody class="">
                              <tr *ngFor="let item of GridTranslist; let i = index" id="tr{{ i+1 }}">
                                <td>{{i+1}}</td>
                                <td style="display:none">{{item.TransID}}</td>
                                <td><input type='text' value="{{item.ColumnData}}" id="txt_columndata" class="form-control" /></td>
                                <td><input type='text' value="{{item.ColumnTitle}}" id="txt_ColumnTitle" class="form-control" /></td>
                                <td><input type='text' value="{{item.ColumnDataType}}" id="txt_ColumnDataType" class="form-control" /></td>
                                <td><input type='text' value="{{item.ColumnReturnData}}" id="txt_ColumnReturnData" class="form-control" /></td>
                                <td align="center"><input type='checkbox' name='IsVisible' id="bool_sortable" [checked]="item.Sortable" /></td>
                                <td><input type='text' value="{{item.Alignment}}" id="txt_Alignment" class="form-control" /></td>
                                <td><input type='number' value="{{item.Actions}}" id="txt_Actions" min="0" max="1" class="form-control" style="width:70px" /></td>
                                <td><input type='number' value="{{item.DisplayOrder}}" id="txt_displayorder" style="width: 70px" class="form-control" /></td>
                                <td align="center"><input type='checkbox' name='IsVisible' id="bool_visible" [checked]="item.Visible" /></td>
                                <td align="center"><input type='checkbox' name='IsVisible' id="bool_isdelete" [checked]="item.Transdelete" /></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!--Table end-->
                  </div>
                </div>
                <!--tab body end-->
              </div>
              <!--popupbody end-->
              <!--popup footer-->
              <div class="modal-footer">
                <div class="col-sm-12" style="text-align:right;">                
                  <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin"(click)="deletelastrow()"><i class="fa fa-trash"></i>delete</button>&nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-outline-success waves-effect waves-light clsMargin" (click)="updateFieldDetails()">{{popupButtonText}}</button>&nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" (click)="hide()">Close</button>&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </div>
          <div id="LoadingImageReopen">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
          </div>
        </div>
        <!--popup end-->
      </div>
    </div>
  </div>
</div>
